<template>
  <app-popup :active.sync="active" title="Настройки приложения" class="app-settings-popup">
    <div>
      <div class="app-settings-popup__row app-settings-popup__row_switch">
        <label class="app-input__label">Повышенная контрастность</label>
        <app-switch v-model="isAppContrast"/>
      </div>
      <div class="app-settings-popup__row app-settings-popup__row_switch" v-if="showFontSettings">
        <label class="app-input__label">Увеличенный шрифт</label>
        <app-switch v-model="isAppFontLarger"/>
      </div>
    </div>
  </app-popup>
</template>

<script>
  export default {
    name: "AppSettingsPopup",
    props: {
      showFontSettings: {
        default: false
      }
    },
    data(){
      return {
        active: false
      }
    },
    computed: {
      isAppContrast: {
        get(){
          return this.$store.getters['highContrast'];
        },
        set(v){
          this.$store.dispatch('UPDATE_HIGH_CONTRAST', v);
        }
      },
      isAppFontLarger: {
        get(){
          return this.$store.getters['fontLarger'];
        },
        set(v){
          this.$store.dispatch('UPDATE_APP_FONT_LARGER', v);
        }
      }
    },
    methods: {
      open() {
        this.active = true;
      }
    }
  }
</script>

<style lang="scss">
  .app-settings-popup{

    &__row{

      &:not(:last-child){
        margin-bottom: 15px;
      }

      &_switch{
        display: flex;
        align-items: center;
        justify-content: space-between;

        .app-input__label{
          margin-bottom: 0;
          margin-right: 10px;
        }
      }

    }

  }
</style>
